import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { api } from '../lib/api'
import DocumentShell from '../features/documents/DocumentShell'
import RateConfirmationView from '../features/documents/RateConfirmationView'
import { formatDate, shortId } from '../features/documents/documentFormatters'

function unwrap<T>(value: any): T {
  const payload = value?.data ?? value
  return payload?.load ?? payload?.job ?? payload?.invoice ?? payload
}

export default function RateConfirmationPage() {
  const { loadId } = useParams<{ loadId: string }>()

  const { data: load } = useQuery({
    queryKey: ['document-pack-load', loadId],
    queryFn: async () => unwrap(await api.loads.get(loadId!)),
    enabled: !!loadId,
  })

  const { data: jobs = [] } = useQuery({
    queryKey: ['document-pack-jobs'],
    queryFn: async () => (await api.jobs.list()).data,
  })

  const { data: invoices = [] } = useQuery({
    queryKey: ['document-pack-invoices'],
    queryFn: async () => (await api.invoices.list({ loadId: loadId! })).data,
    enabled: !!loadId,
  })

  if (!loadId) {
    return <div className="container mx-auto p-6 text-red-600">Load ID is missing.</div>
  }

  if (!load) {
    return <div className="container mx-auto p-6 text-red-600">Load not found.</div>
  }

  const job = jobs.find((entry: any) => String(entry.loadId ?? entry.load_id) === String(loadId))
  const invoice = invoices[0]
  const loadLabel = load.load_number ?? load.loadNumber ?? shortId(load.id)

  return (
    <DocumentShell
      title="Rate Confirmation"
      subtitle={`Load ${loadLabel}`}
      meta={[
        { label: 'Load', value: loadLabel },
        { label: 'Issued', value: formatDate(job?.assignedAt ?? load.updated_at ?? load.createdAt ?? load.created_at) },
        { label: 'Vehicles', value: Array.isArray(load.vehicles) ? String(load.vehicles.length) : '0' },
        { label: 'Status', value: load.status ?? 'TBD' },
      ]}
      actions={
        <>
          {job?.id && <Link to={`/jobs/${job.id}/dispatch-sheet`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Dispatch Sheet</Link>}
          {job?.id && <Link to={`/jobs/${job.id}/bol`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">BOL</Link>}
          {job?.id && <Link to={`/jobs/${job.id}/pod`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">POD</Link>}
          <Link to={`/loads/${loadId}`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Back to Load</Link>
        </>
      }
    >
      <RateConfirmationView load={load} job={job} invoice={invoice} />
    </DocumentShell>
  )
}
